import axios from 'axios';

const loadIcons = ({ navigationApiUrl, iconPackId }) => {
    const url = `${navigationApiUrl}/asset-manager-api/v1/icon-packs/${iconPackId}`;
    return axios.get(url)
        .then(res => (res.data))
        .catch(() => null);
};

export default loadIcons;
